import React from 'react';
import {AutoField} from 'components/forms/fields';
import EndSection from 'components/forms/EndSection';
import {Grid, Typography} from '@material-ui/core';
import fields from 'components/forms/cpr/fields';
import {bootstrapOldForm} from '../AutoSection';
import {SiteUrls} from '../../../constants';

const CprFaTrainingCert = props => {
    const {schema, initialValues, sectionFields} = bootstrapOldForm(
        'CPR',
        fields
    );
    return (
        <EndSection
            {...props}
            {...{schema, initialValues}}
            redirectUrl={SiteUrls.TRAINING}
        >
            <Typography variant='h6' align='left'>
                CPR/First Aid Training Certificate Info
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant='body1'>
                        Let's enter the information about this CPR/First Aid
                        Training Certificate.
                    </Typography>
                </Grid>
                {sectionFields?.map(field => (
                    <Grid item key={field} xs={12}>
                        <AutoField field={fields[field]} name={field} />
                    </Grid>
                ))}
                {props?.children}
            </Grid>
        </EndSection>
    );
};

export default CprFaTrainingCert;
